import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export default function PDFViewer({ imageUrl }: { imageUrl: any }) {
    const [pageNumber, setPageNumber] = useState(1);

    // when the document is loaded, total page count is available
    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setPageNumber(numPages);
    };

    const S3_BUCKET = process.env.REACT_APP_API_URL_S3_BUCKET_URL;
    // // set to a different page
    // const changePage = (offset) => {
    //     setPageNumber((prevPageNumber) => prevPageNumber + offset);
    // };

    // // go to the previous page
    // const previousPage = () => {
    //     changePage(-1);
    // };

    // // go to the next page
    // const nextPage = () => {
    //     changePage(1);
    // };

    return (
        <div>
            <div className="flex justify-center ">
                <div className="max-w-full md:max-w-2xl">
                    <Document
                        file={S3_BUCKET + imageUrl}
                        onLoadSuccess={onDocumentLoadSuccess}
                    >
                        {/* <Page pageNumber={pageNumber} renderAnnotationLayer={false} renderTextLayer={false} /> */}
                        {Array.from(new Array(pageNumber), (_, index) => (
                            <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                            />
                        ))}
                    </Document>
                </div>
            </div>
            {/* <div className="flex justify-between ">
                <button
                    type="button"
                    disabled={pageNumber <= 1}
                    onClick={previousPage}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                    Previous
                </button>
                <button
                    type="button"
                    disabled={pageNumber >= numPages}
                    onClick={nextPage}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                    Next
                </button>
            </div> */}
        </div>
    );
}
